import React,{useEffect} from "react";
import "./style.css"
import { useNavigate } from "react-router-dom";
import config from "../../config/config"
import api from "../../config/axios";
import ProductCard from "../../components/ProductCard/ProductCard";
import Loader from "../../components/Loader/Loader";

const ProductCategoryList = () => {
  const [cartCount, setCartCount] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [products, setProducts] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const productsPerPage = 150;

  useEffect(() => {
    api.get("/by-category")
      .then((res) => {
        setProducts(res.data);
        setIsLoading(false);
      })
      .catch((err) => console.error("Erro ao buscar produtos:", err));
  }, []);

  

  // Calculate pagination
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );
  const totalPages = Math.ceil(products.length / productsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container">
      <Loader text="Loading products..." is_shown={isLoading} />
      {/* <div className="filters">
        <div className="search-box">
          <input type="text" placeholder="Search products..." />
          <i className="fas fa-search"></i>
        </div>

        <div className="filter-options">
          <select className="filter-select">
            <option>Todas Categorias</option>
          </select>

          <select className="filter-select">
            <option>Preço: Baixo para Alto</option>
            <option>Preço: Alto para Baixo</option>
            <option>Mais Popular</option>
            <option>Mais Recente</option>
          </select>
        </div>
      </div> */}

      <div className="products-grid">
        {currentProducts.map((product) => (
           product.stock && product.stock.quant_available > 0 && (<ProductCard key={product.id} product={product} />)
          
        ))}
      </div>

      {/* <div className="pagination">
        <button onClick={() => paginate(1)} disabled={currentPage === 1}>
          <i className="fas fa-angle-double-left"></i>
        </button>

        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => paginate(index + 1)}
            className={currentPage === index + 1 ? "active" : ""}
          >
            {index + 1}
          </button>
        ))}

        <button
          onClick={() => paginate(totalPages)}
          disabled={currentPage === totalPages}
        >
          <i className="fas fa-angle-double-right"></i>
        </button>
      </div> */}
    </div>
  );
};

export default ProductCategoryList;
